import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageLineComponent, MessageLineSmallComponent } from './messageline.component';
import { DashboardItemComponent } from './dashboard-item.component';
import { MenupointComponent } from './menupoint.component';
import { HeaderPersonalComponent } from './hd-personal.component';
import { HeaderMessagesComponent } from './hd-messages.component';
import { VertragShortComponent } from './vertrag-short.component';
import { TableComponent } from './table.component';

import { ExternFooterComponent } from './extern-footer.component';
import { FileUploadComponent } from './file-upload.component';
import { BurgscheinTableSubComponent } from './bgsch-table-add.component';

import { Pager } from './pager.component';

import { PipeModule } from '../pipes.module/pipes.module';
import { PrintButton } from './print/button.component';
import { PrintHeader } from './print/header.component';
import { PrintEnthaftungserklaerung } from './print/enthaftungserklaerung.component';
import { PrintPartnerAenderung } from './print/partneraenderung.component';

import { MessageComponent } from './modals/message.component';
import { ConfirmComponent } from './modals/confirm.component';
import { ErrorComponent } from './modals/error.component';
import { AuftraggeberSucheComponent } from './auftraggeber-suche.component';
import { ErweiterteAuftraggeberSucheComponent } from './modals/erweiterte-auftraggeber-suche.component';
import { NewTableComponent } from './new-table.component';
import { ButtonComponent } from './button.component';
import { TextareaComponent } from './textarea.component';
import { TooltipComponent } from './tooltip.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        MessageLineComponent,
        MessageLineSmallComponent,
        MenupointComponent,
        DashboardItemComponent,
        HeaderPersonalComponent,
        HeaderMessagesComponent,
        VertragShortComponent,
        TableComponent,
        MessageComponent,
        ConfirmComponent,
        ErrorComponent,
        ExternFooterComponent,
        FileUploadComponent,
        BurgscheinTableSubComponent,
        Pager,
        PrintPartnerAenderung,
        PrintEnthaftungserklaerung,
        PrintHeader,
        PrintButton,
        AuftraggeberSucheComponent,
        ErweiterteAuftraggeberSucheComponent,
        NewTableComponent,
        ButtonComponent,
        TextareaComponent,
        TooltipComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        PipeModule,
    ],
    exports: [
        MessageLineComponent,
        MenupointComponent,
        DashboardItemComponent,
        HeaderPersonalComponent,
        HeaderMessagesComponent,
        VertragShortComponent,
        TableComponent,
        MessageComponent,
        ConfirmComponent,
        ErrorComponent,
        ExternFooterComponent,
        FileUploadComponent,
        Pager,
        PrintButton,
        PrintHeader,
        PrintEnthaftungserklaerung,
        PrintPartnerAenderung,
        AuftraggeberSucheComponent,
        ErweiterteAuftraggeberSucheComponent,
        ButtonComponent,
        TextareaComponent,
        TooltipComponent,
        NewTableComponent
    ],
    bootstrap: [],
})
export class ElementsModule {
}
